import React, { useEffect, useState, useRef } from "react";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { deleteItem, listItems } from "../../helper/api";
import { formatCurrency, formatDate } from "../../service/format";

export default function SupplyList(props){
    const { travel } = props;
    const [ supplies, setSupplies ] = useState([]);
    const [supply, setSupply] = useState(false);
    const dt = useRef(null);

    const actionBodyTemplate = (rowData) => {
        return (
            <div className="actions">
                <Button icon="pi pi-trash" className="p-button-rounded p-button-danger mr-2" onClick={() => {
                    setSupply(rowData.code);
                }} />
            </div>
        );
    }

    const list = () => listItems(`/supply/travel/${travel.code}`).then(setSupplies);

    useEffect(() => {
        list();
    }, [props.supply]);

    return (
        <>
            <Dialog visible={Number.isInteger(supply)} style={{ width: '450px' }} header="Atenção" modal footer={() => (
                <>
                    <Button label="Não" icon="pi pi-times" className="p-button-text" onClick={() => {
                        setSupply(false);
                    }} />
                    <Button label="Sim" icon="pi pi-check" className="p-button-text" onClick={() => {
                        deleteItem(`/supply/${supply}`).then(message => {
                            props.onDelete({ success: true, message });
                            list();
                        }).catch(error => {
                            props.onDelete({ success: false, error });
                        }).finally(() => setSupply(false));
                    }} />
                </>
            )} onHide={() => setSupply(false)}>
                <div className="flex align-items-center justify-content-center">
                    <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: '2rem' }} />
                    <span>Você tem certeza que deseja remover este abastecimento? 
                        A despesa vinculada ao abastecimento também será excluída.</span>
                </div>
            </Dialog>
            <DataTable ref={dt} 
                dataKey="id"  className="datatable-responsive"
                paginatorTemplate="" value={supplies}
                emptyMessage="Nenhum registro encontrado." header={() => (
                    <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
                        <h5 className="m-0">Abastecimentos</h5>
                    </div>
                )} responsiveLayout="scroll">
                <Column field="kilometer"  header="Quilometragem"></Column>
                <Column field="amount" body={rowData => (rowData.amount || 0) ? (formatCurrency(rowData.amount, true)) : '-'} header="Valor"></Column>
                <Column field="litre" body={rowData => (rowData.litre || 0) ? (formatCurrency(rowData.litre)) : '-'} header="Litros"></Column>
                <Column field="createdat" body={rowData => (rowData.createdat || 0) ? (formatDate(rowData.createdat, false)) : '-'} header="Data"></Column>
                {travel.status !== 'done' ? <Column body={actionBodyTemplate} style={{width: '20%', whiteSpace: 'nowrap'}}></Column> : <></>}
            </DataTable>  
        </>
        
    );
}